var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProductLongLine = function SvgProductLongLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 451,
    height: 105,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 451 105"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint0_linear_129_15346)",
    strokeDasharray: "3 3",
    d: "M1 104.364V66.979c0-9.06 6.141-16.452 17.25-16.852.314-.011 410.472-.017 410.795-.017 11.711 0 21.204-7.553 21.204-16.87V0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_15346",
    x1: -110.25,
    x2: -110.25,
    y1: 29.5,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE"
  })))));
};
export { SvgProductLongLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUxIiBoZWlnaHQ9IjEwNSIgdmlld0JveD0iMCAwIDQ1MSAxMDUiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDEwNC4zNjRMMSA2Ni45Nzg5QzEgNTcuOTE4OSA3LjE0MTA3IDUwLjUyNzEgMTguMjQ5NSA1MC4xMjdDMTguNTYzOSA1MC4xMTU3IDQyOC43MjIgNTAuMTA5OSA0MjkuMDQ1IDUwLjEwOTlDNDQwLjc1NiA1MC4xMDk5IDQ1MC4yNDkgNDIuNTU3NCA0NTAuMjQ5IDMzLjI0MDlMNDUwLjI0OSAwLjAwMDExMTE5IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8xMjlfMTUzNDYpIiBzdHJva2UtZGFzaGFycmF5PSIzIDMiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8xMjlfMTUzNDYiIHgxPSItMTEwLjI1IiB5MT0iMjkuNSIgeDI9Ii0xMTAuMjUiIHkyPSIxMDMuNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjN0Y3Njc4Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGRUVFRSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";